<template>
<div
     v-if="profile != null"
>
    <v-switch
        label="Promotion Prohibited:  That is, RedChirp may not use this organization in any promotion(s)"
        v-on:change="patch"
        v-model="profile.organization_account.red_chirp_promotion_prohibited"
    />

        <v-switch
        label="Branded Link Shortener"
        v-on:change="patch"
        v-model="profile.organization_account.provision_branded_link_shortener"
    />

    <v-switch
        label="Outbound Calling (do not turn unless you are *absolutely* sure)"
        v-on:change="patch"
        v-model="profile.organization_account.provision_outbound_calling"
    />

    <v-switch
        label="Conditional Automated Messages"
        v-on:change="patch"
        v-model="profile.organization_account.provision_conditional_auto_message"
    />

        <v-switch
        label="Alarm when webchat is not shown yesterday or today (webchat monitoring)"
        v-on:change="patch"
        v-model="profile.organization_account.features.alarm_widget_not_shown_yesterday_or_today"
    />

    
    <v-switch
        label="Subject to FINRA archival requirements"
        v-on:change="patch"
        v-model="profile.organization_account.features.compliance_finra"
        :disabled="!$rc.$state.authAccountHasRedChirpStaffRole('administrator')"
    />

    <m-edit-text
        label="FINRA Retention Email Records To"
        v-model="profile.organization_account.features.compliance_finra_email_addresses"
        v-on:input="patch"
        hint="Set very carefully -- a copy of *all* communications will be emailed to these address(es) every day!"
    />

    <m-edit-text
        label="Limit monthly outgoing messages"
        v-model="profile.organization_account.limit_monthly_outgoing_message"
        v-on:input="patch"
        optional
        unset_label="No limit"
    />

    <v-switch
      label="Is Sandbox Account"
      v-model="profile.organization_account.is_sandbox_organization"
      v-on:change="patch"
      style="margin-top: -15px"
      hint="Sanbox accounts can't (1) modify their integration settings of (2) place automated messages into auto send mode"
      persistent-hint 
    />


    <v-switch
        label="This section is complete"
        v-model="profile.provision_info.complete_features"
        v-on:change="onChangeCompleteSwitch"
    />

</div>
</template>

<script>
export default {
    props: {
         profile: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        patch()
        {
            let organization_account = this.profile.organization_account;

            let patch = {
                'organization_id': organization_account.organization_id,
                'provision_branded_link_shortener' : organization_account.provision_branded_link_shortener,
                'provision_outbound_calling' : organization_account.provision_outbound_calling,
                'provision_conditional_auto_message': organization_account.provision_conditional_auto_message,
                'red_chirp_promotion_prohibited': organization_account.red_chirp_promotion_prohibited,
                'limit_monthly_outgoing_message': organization_account.limit_monthly_outgoing_message ?? -1,
                'is_sandbox_organization': organization_account.is_sandbox_organization,

                'features': {
                        'alarm_widget_not_shown_yesterday_or_today' : organization_account.features.alarm_widget_not_shown_yesterday_or_today,
                        'compliance_finra' : organization_account.features.compliance_finra,
                        'compliance_finra_email_addresses' : organization_account.features.compliance_finra_email_addresses,
                        'message_privacy_mode' : organization_account.features.message_privacy_mode,
                        'show_message_type_indicator' : organization_account.features.show_message_type_indicator,
                        'allow_links_in_bot_messages': organization_account.features.allow_links_in_bot_messages
                },
            };

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/organizations/organization-account',
            
                'params' : patch,
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': 'Unable to save changes to organization',
            });
        },

        onChangeCompleteSwitch() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/provision/provision-info',
            
                'params' : this.profile.provision_info,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to mark the rate card section as complete',
            });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>